import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../components/spinner";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Mensaje } from "../components/mensajes";
import axios from "axios";
import useTableScroll from "../components/useTableScroll.js";

const CatalogoAgenteTipo3 = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "CÓDIGO", textAlign: "center" },
    { label: "NOMBRES", textAlign: "center" },
    { label: "RIF", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarAgente = () => {
    setRecords([]);
    setActivate(true);
    let campos =
      "idagente, nombre, rif, direccion, status1x500, statusente, statusexpe, statusfiscal, statusmina, statusproduccion, statusrenta";
    let nomtab = "agente";
    let nomid = props.tipo;
    let valor = props.valor;
    let orden = "idagente";
    let endpoint = `${op.conexion}/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${valor}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var age = [];
          var status = null;

          for (let i = 0; i < response.data.length; i++) {
            if (props.tipo === "mina") {
              status = response.data[i].statusmina;
            } else if (props.tipo === "produccion") {
              status = response.data[i].statusproduccion;
            } else if (props.tipo === "impuesto1x500") {
              status = response.data[i].status1x500;
            } else if (props.tipo === "expendedor") {
              status = response.data[i].statusexpe;
            } else if (props.tipo === "ente") {
              status = response.data[i].statusente;
            } else if (props.tipo === "fiscal") {
              status = response.data[i].statusfiscal;
            } else if (props.tipo === "renta") {
              status = response.data[i].statusrenta;
            }

            if (status === "51") {
              age.push({
                idagente: response.data[i].idagente,
                nombre: response.data[i].nombre,
                rif: response.data[i].rif,
                direccion: response.data[i].direccion,
                status: status,
              });
            }
          }
          setRecords(age);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatAge();
  };

  const seleccionarAgentes = () => {
    blanquear();
    props.onHideAceptaCatAge(
      values.idage,
      values.nombage,
      values.rif,
      values.direccion,
      values.status
    );
    props.onHideCancelaCatAge();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setActivo(false);
    setItemSelect(index);
    setValues({
      idage: recordsAfterPagingAndSorting()[index].idagente,
      nombage: recordsAfterPagingAndSorting()[index].nombre,
      rif: recordsAfterPagingAndSorting()[index].rif,
      direccion: recordsAfterPagingAndSorting()[index].direccion,
      status: recordsAfterPagingAndSorting()[index].status,
    });
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="lg"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarAgente();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3 className="text-capitalize">
            {"Contribuyentes de - "}
            {props.tipo === "idtipoagente" ? "timbres" : props.tipo}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row col-md-12" style={{ marginBottom: "2px" }}>
          <div className="input-group col-md-4 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control"
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idagente}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombre}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.rif}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarAgentes}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};

export default CatalogoAgenteTipo3;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoAgenteTipo3.js